import { Input, Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { MenuItem } from 'primeng/api';
import { AppComponent } from '../../app.component';
import { BreadcrumbService } from '../services/app.breadcrumb.service';
import { ApiService, UserService } from '../services';
import { UserModel } from '../models/user-management';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html'
})
export class AppTopBarComponent implements OnDestroy, OnInit {

    subscription: Subscription;
    public currentUser: UserModel;
    public priceDilog: boolean;
    public languageOptions: any[] = [
        { label: "Eng", value: "en", icon: "" },
        { label: "Рус", value: "ru", icon: "" },
        { label: "Uzb", value: "uz", icon: "" },
    ];

    public selectedLanguage: { label: string, value: string } | null = null;
    public languageMenuItems: any[];

    items: MenuItem[];

    @Input() public appMain: any;

    constructor(
        public breadcrumbService: BreadcrumbService,
        public app: AppComponent,
        private readonly userService: UserService,
        private readonly apiService: ApiService,
        private readonly translate: TranslateService) {
        this.subscription = breadcrumbService.itemsHandler.subscribe(response => {
            this.items = response;
        });
    }

    ngOnInit() {
        this.currentUser = this.userService.getProfile();
        if (!this.currentUser) {
            this.apiService.get('api/User/GetProfile')
                .subscribe(u => {
                    this.currentUser = u;
                    this.userService.setProfile(u);
                });
        }
        const langCode = localStorage.getItem("edent-language") ?? localStorage.setItem("edent-language", "ru");
        const language = this.languageOptions.find(x => x.value === langCode);
        this.selectedLanguage = language;
    }

    ngOnDestroy() {
        this.subscription?.unsubscribe();
    }

    public viewPrice() {
        this.priceDilog = true;
    }

    public closePrice() {
        this.priceDilog = false;
    }

    public logout() {
        this.userService.purgeAuth();
    }

    public changeLanguage(language: any) {
        this.selectedLanguage = language;
        localStorage.setItem("edent-language", language.value);
        this.translate.use(language.value);
        window.location.reload();
    }
}
